import {procParamChoose, procParamSearch, procParamSearchNextPage} from '../services/procSearch';
import {setText, formZoom} from '../../../_shared/GWTBridge/invoke/procMain';
import {zoomModes} from '../consts/zoomModes';
import {SearchAction} from 'priority-web-sdk/enums';

export function openProcChoose(field, searchQuery) {
    return procParamChoose(field).then((result: any) => {
        if (result.Procedure[0].Choose) {
            return result.Procedure[0].Choose[0];
        } else {
            return openProcSearch(field, searchQuery);
        }
    });
}

export function openProcSearch(field, searchQuery) {
    return procSearch(field, searchQuery, SearchAction.Start, '0', '0');
}

export function procSearch(field, searchQuery, action, stackCursor = '0', searchStart) {
    return procParamSearch(field, searchQuery, action, stackCursor, searchStart).then(
        (result: any) => {
            return result.Procedure[0].Search ? result.Procedure[0].Search[0] : {};
        }
    );
}

export function procSearchNext(field, searchQuery, page, stackCursor, searchStart) {
    return procParamSearchNextPage(field, searchQuery, page, stackCursor, searchStart).then(
        (result: any) => {
            return result.Procedure[0].Search ? result.Procedure[0].Search[0] : {};
        }
    );
}

export function setInputValue(value, field, inputIdx) {
    setText(value, field, inputIdx);
}

export function procFormZoom(field, inputIdx) {
    formZoom(field, inputIdx, zoomModes.fieldValue);
}

export function procZoomToAdvancedSearch(field, inputIdx) {
    formZoom(field, inputIdx, zoomModes.advancedSearch);
}
